var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"i18n",rawName:"v-i18n",value:(_vm.locale),expression:"locale"}],attrs:{"id":"app"}},[_c('Header'),_c('main',{staticClass:"main-content"},[_c('router-view')],1),_c('SideDrawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }